import { render, staticRenderFns } from "./PccLogin.vue?vue&type=template&id=12a1a6ce&scoped=true&"
import script from "./PccLogin.vue?vue&type=script&lang=ts&"
export * from "./PccLogin.vue?vue&type=script&lang=ts&"
import style0 from "./PccLogin.vue?vue&type=style&index=0&id=12a1a6ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1a6ce",
  null
  
)

export default component.exports